import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { IonicModule } from '@ionic/angular';
import { BacknavComponent } from './backnav/backnav.component';
import { LoadingComponent } from './loading/loading.component';
import { MapComponent } from './map/map.component';
import { MaterialModule } from '../material.module';
import { NewPropertyStep1Component } from './new-property-step1/new-property-step1.component';
import { NewPropertyStep2Component } from './new-property-step2/new-property-step2.component';
import { NewPropertyStep3Component } from './new-property-step3/new-property-step3.component';
import { PropertyCardComponent } from './property-card/property-card.component';
import { NewPropertyStep4Component } from './new-property-step4/new-property-step4.component';
import { PropertyFeaturesComponent } from './property-features/property-features.component';
import { PropertyEditComponent } from './property-edit/property-edit.component';
import { FrecuencyInspectionsComponent } from './frecuency-inspections/frecuency-inspections.component';
import { OwnerEditComponent } from './owner-edit/owner-edit.component';
import { TenantEditComponent } from './tenant-edit/tenant-edit.component';
import { ModalAlertComponent } from './dialog/modal-alert/modal-alert.component';
import { ModalSearchOptionsComponent } from './dialog/modal-search-options/modal-search-options.component';
import { ModalSelectReportTypeComponent } from './dialog/modal-select-report-type/modal-select-report-type.component';
import { PropertyCardV2Component } from './property-card-v2/property-card-v2.component';
import { ModalCoAdministradorComponent } from './dialog/modal-co-administrador/modal-co-administrador.component';
import { ReportRegistroFotograficoComponent } from './report-registro-fotografico/report-registro-fotografico.component';
import { ViewPhotoComponent } from './view-photo/view-photo.component';
import { InformeRegistroFotograficoComponent } from './informe-registro-fotografico/informe-registro-fotografico.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ReportCheckInComponent } from './report-check-in/report-check-in.component';
import { NewPropertyStep5Component } from './new-property-step5/new-property-step5.component';
import { PropertyCardV3Component } from './property-card-v3/property-card-v3.component';
import { InformeCheckInComponent } from './informe-check-in/informe-check-in.component';
import { ModalMessageComponent } from './dialog/modal-message/modal-message.component';
import { ModalPhotografiReportComponent } from './dialog/modal-photografi-report/modal-photografi-report.component';
import { AnaexoCheckInComponent } from './anaexo-check-in/anaexo-check-in.component';
import { ModalDeleteReportComponent } from './dialog/modal-delete-report/modal-delete-report.component';
import { ReportRutinaComponent } from './report-rutina/report-rutina.component';
import { InformeRutinaComponent } from './informe-rutina/informe-rutina.component';
import { CameraPreviewComponent } from './camera-preview/camera-preview.component';
import { ReportCheckOutComponent } from './report-check-out/report-check-out.component';
import { TabsmenuComponent } from './tabsmenu/tabsmenu.component';
import { GoogleMapsModule } from "@angular/google-maps";
import { MapGoogleComponent } from './map-google/map-google.component';
import { PropertyCardV4Component } from './property-card-v4/property-card-v4.component';
import { InformeCheckOutComponent } from './informe-check-out/informe-check-out.component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { CropperComponent } from './cropper/cropper.component';
import {NgxImageCompressService} from 'ngx-image-compress';
import { ModalEditNameComponent } from './dialog/modal-edit-name/modal-edit-name.component';

@NgModule({
  declarations: [
    HeaderComponent,
    BacknavComponent,
    LoadingComponent,
    MapComponent,
    NewPropertyStep1Component,
    NewPropertyStep2Component,
    NewPropertyStep3Component,
    NewPropertyStep4Component,
    PropertyCardComponent,
    PropertyFeaturesComponent,
    PropertyEditComponent,
    FrecuencyInspectionsComponent,
    OwnerEditComponent,
    TenantEditComponent,
    ModalAlertComponent,
    ModalSearchOptionsComponent,
    ModalSelectReportTypeComponent,
    PropertyCardV2Component,
    ModalCoAdministradorComponent,
    ReportRegistroFotograficoComponent,
    ViewPhotoComponent,
    InformeRegistroFotograficoComponent,
    ReportCheckInComponent,
    NewPropertyStep5Component,
    PropertyCardV3Component,
    InformeCheckInComponent,
    ModalMessageComponent,
    ModalPhotografiReportComponent,
    AnaexoCheckInComponent,
    ModalDeleteReportComponent,
    ReportRutinaComponent,
    InformeRutinaComponent,
    CameraPreviewComponent,
    ReportCheckOutComponent,
    TabsmenuComponent,
    MapGoogleComponent,
    PropertyCardV4Component,
    InformeCheckOutComponent,
    CropperComponent,
    ModalEditNameComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    MaterialModule,
    NgScrollbarModule,
    GoogleMapsModule,
    ImageCropperComponent

  ],
  exports: [
    HeaderComponent,
    BacknavComponent,
    LoadingComponent,
    MapComponent,
    NewPropertyStep1Component,
    NewPropertyStep2Component,
    NewPropertyStep3Component,
    NewPropertyStep4Component,
    PropertyCardComponent,
    PropertyFeaturesComponent,
    PropertyEditComponent,
    FrecuencyInspectionsComponent,
    OwnerEditComponent,
    TenantEditComponent,
    ModalAlertComponent,
    ModalSearchOptionsComponent,
    ModalSelectReportTypeComponent,
    PropertyCardV2Component,
    ModalCoAdministradorComponent,
    ReportRegistroFotograficoComponent,
    ViewPhotoComponent,
    InformeRegistroFotograficoComponent,
    ReportCheckInComponent,
    NewPropertyStep5Component,
    PropertyCardV3Component,
    InformeCheckInComponent,
    ModalMessageComponent,
    ModalPhotografiReportComponent,
    AnaexoCheckInComponent,
    ModalDeleteReportComponent,
    ReportRutinaComponent,
    InformeRutinaComponent,
    CameraPreviewComponent,
    ReportCheckOutComponent,
    TabsmenuComponent,
    MapGoogleComponent,
    PropertyCardV4Component,
    InformeCheckOutComponent,
    CropperComponent,
    ModalEditNameComponent
  ],
  providers: [NgxImageCompressService]
})
export class ComponentsModule { }
